module.exports = __webpack_public_path__ + "static/media/logoTradeHall.2994a132.svg";